import { VENDOR_OTP_VALIDATE, VENDOR_OTP_VALIDATE_SUCCESS, VENDOR_OTP_VALIDATE_ERROR, VENDOR_OTP_VALIDATE_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const VendorOtpValidate = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_OTP_VALIDATE:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_OTP_VALIDATE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case VENDOR_OTP_VALIDATE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VENDOR_OTP_VALIDATE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VendorOtpValidate;
